module.exports = __webpack_public_path__ + "static/media/selected.077e8efc.svg";